//
import { observer } from "mobx-react-lite";
import React, {
  FC,
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import {
  ImageStyle,
  Platform,
  ScrollView,
  TextStyle,
  ViewStyle,
  SafeAreaView,
  FlatList,
  Alert,
  Dimensions,
  RefreshControl,
  ActivityIndicator,
} from "react-native";
import { api } from "../../../../../services/api";
import { colors, spacing } from "../../../../../theme";
import {
  View,
  Text,
  TextField,
  Card,
  Checkbox,
  DateTimePicker,
  Picker,
  SegmentedControl,
  Assets,
  Spacings,
  Colors,
  BorderRadiuses,
  Timeline,
  GridList,
  GridView,
  Modal,
  SortableList,
  SortableGridList,
  Image,
  Button,
  TabController,
  Avatar,
  TouchableOpacity,
} from "react-native-ui-lib";
import DynamicForm, {
  Col,
  CustomModal,
  CustomNumberInput,
  CustomSelect,
  DangerButton,
  Heading,
  Row,
  SecondaryButton,
  CustomTextField,
  Label,
  CustomCheckbox,
  PrimaryButton,
} from "../../../../../mycomponents/DynamicForm";
import DynamicTable from "../../../../../mycomponents/DynamicTable";
import { useNavigate, useParams } from "react-router-dom";
import { useStores } from "../../../../../mycomponents/state";
import { useNavigationState, useNavigation } from "@react-navigation/native";
import LayoutScreen from "../../../../../mycomponents/CRUD/LayoutScreen";
import FormScreen from "../../../../../mycomponents/CRUD/FormScreen";
import {
  LineChart,
  BarChart,
  PieChart,
  ProgressChart,
  ContributionGraph,
  StackedBarChart,
} from "react-native-chart-kit";
import { QueryBuilder } from "react-querybuilder";
import { QueryBuilderNative } from "@react-querybuilder/native";
import { App } from "antd";
import {
  Agenda,
  DateData,
  AgendaEntry,
  AgendaSchedule,
  CalendarList,
} from "react-native-calendars";
import { LinearGradient } from "expo-linear-gradient";
import { GlobalMasterStore } from "../../../../../mycomponents/state/PermissionStore";
import { Icon } from "react-native-eva-icons";
import { MainScannerScreenComponent } from "../../../../../mycomponents/CRUD/ListingScreen";
import * as Location from "expo-location";
import { FlashList } from "@shopify/flash-list";
import dayjs from "dayjs";
import { Camera, CameraType } from "expo-camera";
import Svg, { G, Path } from "react-native-svg";
import Header from "./Header";
import Shop from "./Shop";
import Footer from "./Footer";

import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedStyle,
} from "react-native-reanimated";
import Carousel from "react-native-reanimated-carousel";
import { LongPressGestureHandler } from "react-native-gesture-handler";

const PAGE_WIDTH = Dimensions.get("window").width;

const boxIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      fill="#080341"
      fillRule="evenodd"
      d="m12 3.663 8.25 4.077v9.27L12 21.086 3.75 17.01V7.74L12 3.663Zm-6.75 5.75v6.665l6 2.965v-6.665l-6-2.965Zm7.5 2.965v6.665l6-2.965V9.413l-2.25 1.112V13.5l-1.5.75v-2.984l-2.25 1.112Zm5.057-4.172-1.954.965a.75.75 0 0 0-.142-.092L10.1 6.275 12 5.336l5.807 2.87ZM8.415 7.108l5.772 2.886L12 11.075l-5.807-2.87 2.222-1.097Z"
      clipRule="evenodd"
    />
  </Svg>
);

const paymentIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="-0.5 0 25 25"
    {...props}
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.92 7.97c.058-.387.085-.778.08-1.17a12.49 12.49 0 0 0-18 0c0 14.06 9 16.17 9 16.17a13.574 13.574 0 0 0 1.92-1M23 13.97H13"
    />
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 10.92h-6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2Z"
    />
  </Svg>
);

const returnIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4}
      d="m13 8-7 6 7 7"
    />
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4}
      d="M6 14h22.994c6.883 0 12.728 5.62 12.996 12.5.284 7.27-5.723 13.5-12.996 13.5H11.998"
    />
  </Svg>
);

const supportIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      stroke="#1C274C"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 9h8M8 12.5h5.5"
    />
    <Path
      fill="#1C274C"
      d="m13.087 21.388.645.382-.645-.382Zm.542-.916-.646-.382.646.382Zm-3.258 0-.645.382.645-.382Zm.542.916.646-.382-.646.382ZM1.25 10.5a.75.75 0 0 0 1.5 0h-1.5Zm1.824 5.126a.75.75 0 0 0-1.386.574l1.386-.574Zm4.716 3.365-.013.75.013-.75Zm-2.703-.372-.287.693.287-.693Zm16.532-2.706.693.287-.693-.287Zm-5.409 3.078-.012-.75.012.75Zm2.703-.372.287.693-.287-.693Zm.7-15.882-.392.64.392-.64Zm1.65 1.65.64-.391-.64.392ZM4.388 2.738l-.392-.64.392.64Zm-1.651 1.65-.64-.391.64.392ZM9.403 19.21l.377-.649-.377.649Zm4.33 2.56.541-.916-1.29-.764-.543.916 1.291.764Zm-4.007-.916.542.916 1.29-.764-.541-.916-1.291.764Zm2.715.152a.52.52 0 0 1-.882 0l-1.291.764c.773 1.307 2.69 1.307 3.464 0l-1.29-.764ZM10.5 2.75h3v-1.5h-3v1.5Zm10.75 7.75v1h1.5v-1h-1.5ZM7.803 18.242c-1.256-.022-1.914-.102-2.43-.316L4.8 19.313c.805.334 1.721.408 2.977.43l.026-1.5ZM1.688 16.2A5.75 5.75 0 0 0 4.8 19.312l.574-1.386a4.25 4.25 0 0 1-2.3-2.3l-1.386.574Zm19.562-4.7c0 1.175 0 2.019-.046 2.685-.045.659-.131 1.089-.277 1.441l1.385.574c.235-.566.338-1.178.389-1.913.05-.729.049-1.632.049-2.787h-1.5Zm-5.027 8.241c1.256-.021 2.172-.095 2.977-.429l-.574-1.386c-.515.214-1.173.294-2.428.316l.025 1.5Zm4.704-4.115a4.25 4.25 0 0 1-2.3 2.3l.573 1.386a5.75 5.75 0 0 0 3.112-3.112l-1.386-.574ZM13.5 2.75c1.651 0 2.837 0 3.762.089.914.087 1.495.253 1.959.537l.783-1.279c-.739-.452-1.577-.654-2.6-.752-1.012-.096-2.282-.095-3.904-.095v1.5Zm9.25 7.75c0-1.622 0-2.891-.096-3.904-.097-1.023-.299-1.862-.751-2.6l-1.28.783c.285.464.451 1.045.538 1.96.088.924.089 2.11.089 3.761h1.5Zm-3.53-7.124a4.25 4.25 0 0 1 1.404 1.403l1.279-.783a5.75 5.75 0 0 0-1.899-1.899l-.783 1.28ZM10.5 1.25c-1.622 0-2.891 0-3.904.095-1.023.098-1.862.3-2.6.752l.783 1.28c.464-.285 1.045-.451 1.96-.538.924-.088 2.11-.089 3.761-.089v-1.5ZM2.75 10.5c0-1.651 0-2.837.089-3.762.087-.914.253-1.495.537-1.959l-1.279-.783c-.452.738-.654 1.577-.752 2.6C1.25 7.61 1.25 8.878 1.25 10.5h1.5Zm1.246-8.403a5.75 5.75 0 0 0-1.899 1.899l1.28.783a4.25 4.25 0 0 1 1.402-1.403l-.783-1.279Zm7.02 17.993c-.202-.343-.38-.646-.554-.884a2.229 2.229 0 0 0-.682-.645l-.754 1.297c.047.028.112.078.224.232.121.166.258.396.476.764l1.29-.764Zm-3.24-.349c.44.008.718.014.93.037.198.022.275.054.32.08l.754-1.297c-.293-.17-.598-.24-.909-.274-.298-.033-.657-.038-1.069-.045l-.025 1.5Zm6.498 1.113c.218-.367.355-.598.476-.764.112-.154.177-.204.224-.232l-.754-1.297c-.29.17-.5.395-.682.645-.173.238-.352.54-.555.884l1.291.764Zm1.924-2.612c-.412.007-.771.012-1.069.045-.311.035-.616.104-.909.274l.754 1.297c.045-.026.122-.058.32-.08.212-.023.49-.03.93-.037l-.026-1.5Z"
    />
  </Svg>
);

const cartIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    height="18px"
    width="18px"
    version="1.1"
    id="Capa_1"
    viewBox="0 0 483.1 483.1"
    {...props}
  >
    <G>
      <path d="M434.55,418.7l-27.8-313.3c-0.5-6.2-5.7-10.9-12-10.9h-58.6c-0.1-52.1-42.5-94.5-94.6-94.5s-94.5,42.4-94.6,94.5h-58.6   c-6.2,0-11.4,4.7-12,10.9l-27.8,313.3c0,0.4,0,0.7,0,1.1c0,34.9,32.1,63.3,71.5,63.3h243c39.4,0,71.5-28.4,71.5-63.3   C434.55,419.4,434.55,419.1,434.55,418.7z M241.55,24c38.9,0,70.5,31.6,70.6,70.5h-141.2C171.05,55.6,202.65,24,241.55,24z    M363.05,459h-243c-26,0-47.2-17.3-47.5-38.8l26.8-301.7h47.6v42.1c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h141.2v42.1   c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h47.6l26.8,301.8C410.25,441.7,389.05,459,363.05,459z" />
    </G>
  </Svg>
);

const isDesktop = Dimensions.get("window").width >= 768;

const ThankYou = observer(function ThankYou(props) {
  const permissions = GlobalMasterStore((state) => state.permissions);
  const employee = GlobalMasterStore((state) => state.employee);
  const [primaryColor, setPrimaryColor] = useState("#cab78d");

  const { message } = App.useApp();

  let navigation = useNavigation();
  let navigate = null;

  if (Platform.OS === "web") {
    navigate = useNavigate();
  }

  const navigationFn = (path, params) => {
    if (Platform.OS === "web") {
      let paramsString = "";
      if (params) {
        paramsString =
          "?" +
          Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");
      }
      navigate("/" + path + paramsString);
    } else {
      if (path.includes("report/")) {
        navigation.navigate("report", {
          ...params,
          name: path.replace("report/", ""),
        });
      } else {
        navigation.navigate(path, params);
      }
    }
  };

  const MainWrapper = useCallback(({ children }) => {
    return !props.hideWrapper ? (
      <>
        <LayoutScreen>
          {Platform.OS == "web" && (
            <View
              marginT-2
              style={{
                flex: 1,
                // backgroundColor: 'red'
              }}
              padding-20
            >
              <Card padding-10>{children}</Card>
            </View>
          )}

          {Platform.OS != "web" && (
            <View
              marginT-2
              style={{
                flex: 1,
              }}
              padding-10
            >
              {children}
            </View>
          )}
        </LayoutScreen>
      </>
    ) : (
      <>{children}</>
    );
  }, []);

  const [products, setProducts] = useState([]);
  const [checkoutData, setCheckoutData] = useState(localStorage.getItem("checkoutData") ? JSON.parse(localStorage.getItem("checkoutData")) : {});

  const getProducts = async () => {
    const response = await api.customRoute("shop/getProducts", {
      page: 1,
      perPage: 8,
    });
    setProducts(response.data.data);
  };

  useEffect(() => {
    getProducts();
  }, []);

  const animationStyle = React.useCallback((value) => {
    "worklet";

    const zIndex = interpolate(value, [-1, 0, 1], [10, 20, 30]);
    const translateX = interpolate(
      value,
      [-2, 0, 1],
      [-PAGE_WIDTH, 0, PAGE_WIDTH]
    );

    return {
      transform: [{ translateX }],
      zIndex,
    };
  }, []);

  return (
    <>
      <ScrollView
        style={{
          height: Dimensions.get("window").height,
          width: Dimensions.get("window").width,
        }}
      >
        <View style={{
          position: 'relative',
        }}>
          <Header theme={"white_bg"} />
          <View style={[{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            overflow: "hidden",
            height: 70,
            minHeight: 70,
            borderWidth: 1,
            borderColor: "#e5e7eb",
          }]}>
          </View>
        </View>
        <Card>

          <View
            marginB-0
            style={{
              borderRadius: 10,
              borderBottomEndRadius: 0,
              borderBottomStartRadius: 0,
            }}
          >
            {/* testimony cards--------- */}

            <Row
              paddingV-40
              paddingH-20
              style={{
                backgroundColor: "#F9F5F2",
                overflow: "hidden",
              }}
            >

              <Col width={isDesktop ? "100%" : "100%"}>
                <View
                  paddingV-40
                  paddingH-40
                  style={{
                    backgroundColor: "#F9F5F2",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Card style={{
                    width: "100%",
                    padding: 20,
                  }}>
                    <View
                      left
                      style={{
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      <Text
                        style={{
                          color: "#414223",
                          fontWeight: "bold",
                          fontSize: 20,
                          display: "flex",
                          textAlign: "left",
                        }}
                      >
                        Thank You For Shopping, {checkoutData?.customer_name}!
                      </Text>
                    </View>

                    <View
                      style={{
                        display: "flex",
                        width: "100%",
                        height: 2,
                        backgroundColor: "#CBCBCB",
                        marginBottom: 20,
                        marginTop: 20,
                      }}
                    ></View>

                    <View
                      style={{
                        justifyContent: "flex-start",
                        paddingBottom: 20,
                      }}
                    >
                      <Text
                        style={{
                          color: "#414223",
                          fontWeight: "bold",
                          fontSize: 14,
                          textAlign: "left",
                        }}
                      >
                        Your order has been placed successfully!
                        Your order id is #{checkoutData?.invoice_number}.
                      </Text>
                    </View>

                    {/* <View>
                      <Row>
                        <Col width="60%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                // fontWeight: 'bold',
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Bridal Lehenga - Red
                            </Text>
                          </View>
                        </Col>
                        <Col width="40%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                // fontWeight: 'bold',
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Rs. 5,999/-
                            </Text>
                          </View>
                        </Col>
                      </Row>

                      <Row>
                        <Col width="60%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Delivery
                            </Text>
                          </View>
                        </Col>
                        <Col width="40%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Rs. 120/-
                            </Text>
                          </View>
                        </Col>
                      </Row>
                      <Row>
                        <Col width="60%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              GST
                            </Text>
                          </View>
                        </Col>
                        <Col width="40%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#ADADAD",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              12%
                            </Text>
                          </View>
                        </Col>
                      </Row>

                      <Row>
                        <Col width="60%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#414223",
                                fontWeight: "bold",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Total
                            </Text>
                          </View>
                        </Col>
                        <Col width="40%">
                          <View
                            style={{
                              justifyContent: "flex-start",
                              paddingBottom: 5,
                            }}
                          >
                            <Text
                              style={{
                                color: "#414223",
                                fontWeight: "bold",
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Rs. 5,999/-
                            </Text>
                          </View>
                        </Col>
                      </Row>
                    </View>

                    <View
                      style={{
                        display: "flex",
                        width: "100%",
                        height: 2,
                        backgroundColor: "#CBCBCB",
                        marginBottom: 20,
                        marginTop: 20,
                      }}
                    ></View>
                    <View
                      style={{
                        justifyContent: "flex-start",
                        paddingBottom: 5,
                      }}
                    >
                      <Text
                        style={{
                          color: "#414223",
                          fontWeight: "bold",
                          fontSize: 14,
                          textAlign: "left",
                        }}
                      >
                        Payment Method
                      </Text>
                    </View>

                    <View
                      style={{
                        justifyContent: "flex-start",
                        paddingBottom: 5,
                      }}
                    >
                      <Text
                        style={{
                          color: "#ADADAD",
                          fontSize: 14,
                          textAlign: "left",
                        }}
                      >
                        {checkoutData?.payment_details?.payment_mode}
                      </Text>
                    </View> */}

                    {/* <View
                      style={{
                        justifyContent: "flex-start",
                        paddingBottom: 5,
                      }}
                    >
                      <Text
                        style={{
                          color: "#414223",
                          fontWeight: "bold",
                          fontSize: 14,
                          textAlign: "left",
                        }}
                      >
                        Ship to
                      </Text>
                    </View> */}

                    {/* <View
                      style={{
                        justifyContent: "flex-start",
                        paddingBottom: 5,
                      }}
                    >
                      <Text
                        style={{
                          color: "#ADADAD",
                          fontSize: 14,
                          textAlign: "left",
                        }}
                      >
                        #123, Exotic Villas, Panchvati, Bhopal
                      </Text>
                    </View> */}
                  </Card>
                </View>
              </Col>

              <Col width={isDesktop ? "100%" : "100%"} style={{ borderLeftWidth: "1px solid #CBCBCB" }}>
                <View center style={{
                  width: "100%",
                  height: "300px",
                }}>
                  <Image
                    source={{
                      uri: `https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/136424061686074460000.png`,
                    }}
                    style={{ width: "300px", height: "300px" }}
                  />
                </View>
                <View center style={{
                  width: "100%",
                  height: "160px",
                }}>
                  <TouchableOpacity onPress={() => {
                    navigationFn("shop/products", {});
                  }} style={{
                    backgroundColor: '#fff',
                    border: '2px solid #cab78d',
                    color: '#cab78d',
                    padding: 10,
                    width: isDesktop ? 200 : '100%',
                    alignItems: 'center',
                    paddingVertical: 10,
                    paddingHorizontal: 30,
                  }}
                  ><Text>
                      Continue Shopping
                    </Text></TouchableOpacity>
                </View>
              </Col>
            </Row>

            <View backgroundColor="white">
              <Row marginV-200 paddingH-20>
                <Col width="100%">
                  <iframe
                    src="https://widget.taggbox.com/144573"
                    style={{
                      width: "100%",
                      border: "none",
                      height: "600px",
                    }}
                  ></iframe>
                </Col>
              </Row>
            </View>

            {/* Footer--------- */}
          </View>

          <Footer />
        </Card>
      </ScrollView>
    </>
  );
});

export default ThankYou;

const CustomItem = ({ index, animationValue }) => {
  const maskStyle = useAnimatedStyle(() => {
    const backgroundColor = interpolateColor(
      animationValue.value,
      [-1, 0, 1],
      ["#000000dd", "transparent", "#000000dd"]
    );

    return {
      backgroundColor,
    };
  }, [animationValue]);

  return (
    <View style={{ flex: 1 }}>
      <SBItem key={index} index={index} style={{ borderRadius: 0 }} />
      <Animated.View
        pointerEvents="none"
        style={[
          {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
          maskStyle,
        ]}
      />
    </View>
  );
};

const SBItem = (props) => {
  const { style, index, pretty, testID, ...animatedViewProps } = props;
  const enablePretty = false;
  const [isPretty, setIsPretty] = React.useState(pretty || enablePretty);

  return (
    <LongPressGestureHandler
      onActivated={() => {
        setIsPretty(!isPretty);
      }}
    >
      <Animated.View testID={testID} style={{ flex: 1 }} {...animatedViewProps}>
        {isPretty ? (
          <SBImageItem
            style={style}
            index={index}
            showIndex={typeof index === "number"}
          />
        ) : (
          <SBTextItem style={style} index={index} />
        )}
      </Animated.View>
    </LongPressGestureHandler>
  );
};

const SBImageItem = ({ style, index: _index, showIndex = true }) => {
  const index = (_index || 0) + 1;
  const source = React.useRef({
    uri: `https://picsum.photos/id/${index}/400/300`,
  }).current;

  return (
    <View
      style={[
        {
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: 8,
          overflow: "hidden",
        },
        style,
      ]}
    >
      <ActivityIndicator size="small" />
      <Image
        key={index}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        source={source}
      />
      <Text
        style={{
          position: "absolute",
          color: "white",
          fontSize: 40,
          backgroundColor: "#333333",
          borderRadius: 5,
          overflow: "hidden",
          paddingHorizontal: 10,
          paddingTop: 2,
        }}
      >
        {showIndex ? index : ""}
      </Text>
    </View>
  );
};

const SBTextItem = ({ style, index }) => {
  return (
    <View
      style={[
        {
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: 8,
        },
        style,
      ]}
    >
      <Image
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        source={{ uri: `https://picsum.photos/id/${index}/1920/1080` }}
      />
    </View>
  );
};
